// extracted by mini-css-extract-plugin
export default {"avatar_user":"AvatarUser_avatar_user__Gf8+o"};